import { render, staticRenderFns } from "./_RiskAversion.vue?vue&type=template&id=7982b996&scoped=true"
import script from "./_RiskAversion.vue?vue&type=script&lang=js"
export * from "./_RiskAversion.vue?vue&type=script&lang=js"
import style0 from "./_RiskAversion.vue?vue&type=style&index=0&id=7982b996&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7982b996",
  null
  
)

export default component.exports